export var IdPremiumType;
(function (IdPremiumType) {
    IdPremiumType["Blue"] = "Blue";
    IdPremiumType["Purple"] = "Purple";
})(IdPremiumType || (IdPremiumType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdPremiumType.ts
// module id = 443
// module chunks = 3